import findPrice from './findPrice';
import { getProductVariantPrices } from 'helpers/src/prices/getProductVariantPrices';

const findFinalPrice = (variant: GQL.IProductVariant, recommended: boolean = false, vatRate: number | null = null) => {
  if (!variant) {
    return 0;
  }

  const prices = getProductVariantPrices(variant as any);

  return findPrice(prices, recommended, vatRate, variant);
};

export default findFinalPrice;


// WEBPACK FOOTER //
// ./src/helpers/prices/findFinalPrice.ts